module.exports = __webpack_public_path__ + "img/saizi6_QX.244bc644.png";